import { render, staticRenderFns } from "./GradeLevelElement.vue?vue&type=template&id=7954ae42"
import script from "./GradeLevelElement.vue?vue&type=script&lang=js"
export * from "./GradeLevelElement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports